import { PhysicalInventoryStatus } from './physical-inventory-enums';

export class PhysicalInventoryMiscOrders {
    public totalOrders: number = 0;
    public totalValue?: number;
    public reportStatus: PhysicalInventoryStatus = PhysicalInventoryStatus.inProgress;

    public orders: PhysicalInventoryMiscOrderInfo[] = [];
}

export class PhysicalInventoryMiscOrderInfo {
    public orderId: string = '';
    public serviceCenter: string = '';
    public dealerName: string = '';
    public description: string = '';
    public quantity: number = 0;

    public struts: boolean = false;
    public springs: boolean = false;
    public track: boolean = false;
    public hardware: boolean = false;
    public sections: boolean = false;
    public windows: boolean = false;    
}
